import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFilter } from "../../../../context/FilterContext";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomSelect from "../../../CustomControls/CustomSelect";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerProjectList,
  POST_GetCustomerContactPersonDDL,
  POST_GetInvoiceList,
  POST_InvoiceExport,
  POST_InvoiceCancel,
  POST_GetInvoiceSendEmailDetails,
  POST_InvoiceEmailSend,
  POST_InvoiceDownloadPDF,
  POST_InvoicePrint,
  POST_GetInvoiceDetailByID,
  POST_InvoiceChangeDetails,
  POST_EInvoice_Generate,
  POST_InvoiceWhatsAppMessageSend,
  POST_GetAllCustomerRepresentativeDropDown,
  GET_PIF_InvoiceStatus,
  POST_PIF_EnqueueInvoice,
  POST_PIF_CancelInvoice,
  POST_PIF_ResyncJob,
} from "../../../helpers/url_helper";
import { post, postFormData, pifGet, pifPost } from "../../../helpers/api_helper";
import { pifInvoiceSyncPill, pifCancelJobPill } from "../TallyIntegration/pifConstants";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import {
  cleanCsvString,
  customConfirmDialog,
  errorMessage,
  successMessage,
  validateEmail,
  warningMessage,
} from "../CommonFunctions";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const Invoice = () => {
  const { filter, updateFilter } = useFilter();

  const [showFilter, setShowFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "invoice" ? filter?.CurrentPage : 1,
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "invoice" ? filter?.PageSize : 10,
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "invoice" ? filter?.sortBy : "",
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "invoice" ? filter?.orderBy : "asc",
  );

  const [isReset, setIsReset] = useState(false);

  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [pifSync, setPifSync] = useState({}); // InvoiceNo -> { PifSyncStatus, PifQueueId, ... }
  const [customerRepresentativeOptions, setCustomerRepresentativeOptions] =
    useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const statusOptions = [
    { label: "All", value: -1 },
    { label: "Active", value: 1 },
    { label: "Cancel", value: 0 },
  ];

  const paymentStatusOptions = [
    { label: "All", value: -1 },
    { label: "Paid", value: 1 },
    { label: "Pending", value: 0 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      InvoiceNo: filter && filter?.page == "invoice" ? filter?.InvoiceNo : "",
      InwardNo: filter && filter?.page == "invoice" ? filter?.InwardNo : "",
      FromDate:
        filter && filter?.page == "invoice" ? filter?.FromDate : new Date(),
      ToDate: filter && filter?.page == "invoice" ? filter?.ToDate : new Date(),
      CustomerIDEncrypted:
        filter && filter?.page == "invoice" ? filter?.CustomerIDEncrypted : "",
      CustomerName:
        filter && filter?.page == "invoice" ? filter?.CustomerName : "",
      CustomerProjectIDEncrypted:
        filter && filter?.page == "invoice"
          ? filter?.CustomerProjectIDEncrypted
          : "",
      TCNo: filter && filter?.page == "invoice" ? filter?.TCNo : "",
      PaymentStatus:
        filter && filter?.page == "invoice" ? filter?.PaymentStatus : -1,
      Status: filter && filter?.page == "invoice" ? filter?.Status : 1,
      CustomerRepresentativeIDEncrypt:
        filter && filter?.page == "invoice"
          ? filter?.CustomerRepresentativeIDEncrypt
          : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      InvoiceNo,
      InwardNo,
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      CustomerProjectIDEncrypted,
      TCNo,
      PaymentStatus,
      Status,
      CustomerRepresentativeIDEncrypt,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      InvoiceNo: "",
      InwardNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      CustomerProjectIDEncrypted: "",
      TCNo: "",
      PaymentStatus: -1,
      Status: 1,
      CustomerRepresentativeIDEncrypt: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    getCustomerRepresentativeDDL();
  }, []);

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  // Tally sync status for the invoices on screen (S8) — only if the user can see
  // the Sync Queue (FormID 110). Failures are swallowed; the column just stays blank.
  const canSeePifSync =
    formsList?.filter((x) => x?.FormID == 110 && x?.IsRead)?.length > 0;
  // IsAdd on the same form gates the "Sync to Tally" action for not-queued invoices.
  const canQueuePifSync =
    formsList?.filter((x) => x?.FormID == 110 && (x?.IsAdd || x?.IsEdit))?.length > 0;

  const fetchPifSync = () => {
    if (!canSeePifSync || !invoiceList?.length) {
      setPifSync({});
      return;
    }
    const nos = invoiceList
      .map((i) => i.InvoiceNo)
      .filter(Boolean)
      .join(",");
    pifGet(
      `${GET_PIF_InvoiceStatus}?companyIdEnc=${encodeURIComponent(
        AuthUser?.CompanyIDEncrypt
      )}&invoiceNos=${encodeURIComponent(nos)}`
    )
      .then((rows) => {
        const map = {};
        (rows || []).forEach((r) => (map[r.InvoiceNo] = r));
        setPifSync(map);
      })
      .catch(() => setPifSync({}));
  };
  useEffect(() => {
    fetchPifSync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceList]);

  const queueInvoiceForTally = (item) => {
    customConfirmDialog(
      "Sync to Tally",
      `Queue invoice ${item?.InvoiceNo} for Tally sync? The PIF agent will push it on its next run.`,
      () => {
        pifPost(POST_PIF_EnqueueInvoice, {
          CompanyIdEnc: AuthUser?.CompanyIDEncrypt,
          InvoiceIdEnc: item?.InvoiceIDEncrypted,
        })
          .then((res) => {
            if (res?.IsSuccess && res?.QueueId > 0)
              successMessage(res?.Message || "Queued for Tally.");
            else warningMessage(res?.Message || "Not queued — check the PIF configuration.");
            fetchPifSync();
          })
          .catch(() => errorMessage("Could not reach the PIF service."));
      },
      true,
    );
  };

  const resyncInvoiceToTally = (item, s) => {
    customConfirmDialog(
      "Re-sync to Tally",
      `Push the current data of ${item?.InvoiceNo} to Tally? The existing voucher will be updated.`,
      () => {
        pifPost(POST_PIF_ResyncJob, {
          CompanyIdEnc: AuthUser?.CompanyIDEncrypt,
          QueueId: s?.PifQueueId,
        })
          .then((res) => {
            if (res?.IsSuccess) successMessage(res?.Message || "Re-queued for Tally.");
            else warningMessage(res?.Message || "Could not re-sync.");
            fetchPifSync();
          })
          .catch(() => errorMessage("Could not reach the PIF service."));
      },
      true,
    );
  };

  const cancelInvoiceInTally = (item) => {
    customConfirmDialog(
      "Cancel in Tally",
      `Cancel the Tally voucher for ${item?.InvoiceNo}? Tally keeps the voucher number as a void entry with no financial effect.`,
      () => {
        pifPost(POST_PIF_CancelInvoice, {
          CompanyIdEnc: AuthUser?.CompanyIDEncrypt,
          InvoiceIdEnc: item?.InvoiceIDEncrypted,
        })
          .then((res) => {
            if (res?.IsSuccess && res?.QueueId > 0)
              successMessage(res?.Message || "Queued to cancel in Tally.");
            else warningMessage(res?.Message || "Nothing to cancel — this invoice was not synced.");
            fetchPifSync();
          })
          .catch(() => errorMessage("Could not reach the PIF service."));
      },
      true,
    );
  };

  const getCustomerRepresentativeDDL = () => {
    setIsLoading(true);
    post(POST_GetAllCustomerRepresentativeDropDown, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerRepresentativeOptions(
            response?.ListOfCustomerRepresentative?.map((item) => ({
              label: item?.ProjectHandleByName,
              value: item?.ProjectHandleByEncrypted,
              IsDefault: item?.IsDefault,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "invoice",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      PaymentStatus: PaymentStatus,
      Status: Status,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      PaymentStatus: PaymentStatus,
      Status: Status,
    };

    await post(POST_GetInvoiceList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setInvoiceList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypted,
      PaymentStatus: PaymentStatus,
      Status: Status,
      CustomerRepresentativeIDEncrypt: CustomerRepresentativeIDEncrypt,
    };

    post(POST_InvoiceExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = (inputValue) => {
    return post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            })),
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted,
            ).length == 0
          ) {
            formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypted) {
      getCustomerProjectDDL(CustomerIDEncrypted);
    } else {
      setCustomerProjectOptions([]);
      formikFilter.setFieldValue("CustomerProjectIDEncrypted", "");
    }
  }, [CustomerIDEncrypted]);

  const [showCancelInvoiceModal, setShowCancelInvoiceModal] = useState(false);

  const validationSchemaCancelInvoice = Yup.object().shape({
    CancelReason: Yup.string()
      .trim()
      .required("Cancel Reason is required field"),
  });

  const formikCancelInvoice = useFormik({
    validationSchema: validationSchemaCancelInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelInvoice(values, formikHelpers),
    initialValues: {
      InvoiceIDEncrypted: "",
      InvoiceNo: "",
      CancelReason: "",
      EInvoiceIRNNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikCancelInvoice;

  const cancelInvoice = (invoiceID, invoiceNo, eInvoice_irnNo) => {
    formikCancelInvoice.resetForm();
    formikCancelInvoice.setFieldValue("InvoiceNo", invoiceNo);
    formikCancelInvoice.setFieldValue("EInvoiceIRNNo", eInvoice_irnNo);
    formikCancelInvoice.setFieldValue("InvoiceIDEncrypted", invoiceID);
    setShowCancelInvoiceModal(true);
  };

  const handleValidSubmitCancelInvoice = (values) => {
    setIsLoading(true);
    post(POST_InvoiceCancel, {
      InvoiceIDEncrypted: values?.InvoiceIDEncrypted,
      CancelledReason: values?.CancelReason,
      ModifiedByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      EInvoiceIRNNo: values?.EInvoiceIRNNo,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
          setShowCancelInvoiceModal(false);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showSendEmailInvoiceModal, setShowSendEmailInvoiceModal] =
    useState(false);
  const [emailContactPersonOptions, setEmailContactPersonOptions] = useState(
    [],
  );

  const validationSchemaSendEmailInvoice = Yup.object().shape({});

  const formikSendEmailInvoice = useFormik({
    validationSchema: validationSchemaSendEmailInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendEmailInvoice(values, formikHelpers),
    initialValues: {
      InvoiceIDEncrypted: "",
      InvoiceNo: "",
      emailListOfProjectContactPerson: [],
      emailListOfAdditionalContactPerson: [],
      emailAdditionalEmailID: "",
      emailCustomerIDEncrypted: "",
      emailCustomerName: "",
      emailCustomerContactPersonIDEncrypted: "",
      emailContactPerson: "",
      emailDesignation: "",
      emailMobileNo: "",
      emailEmailID: "",
      emailContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      emailListOfProjectContactPerson,
      emailListOfAdditionalContactPerson,
      emailCustomerIDEncrypted,
      emailCustomerName,
      emailCustomerContactPersonIDEncrypted,
      emailContactPerson,
      emailDesignation,
      emailMobileNo,
      emailEmailID,
      emailContactPersonID,
    },
  } = formikSendEmailInvoice;

  const openSendEmailInvoiceDialog = async (invoiceID, invoiceNo) => {
    formikSendEmailInvoice.resetForm();
    formikSendEmailInvoice.setFieldValue("InvoiceNo", invoiceNo);
    formikSendEmailInvoice.setFieldValue("InvoiceIDEncrypted", invoiceID);
    setIsLoading(true);
    await post(POST_GetInvoiceSendEmailDetails, {
      InvoiceIDEncrypted: invoiceID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendEmailInvoice.setFieldValue(
            "emailListOfProjectContactPerson",
            response?.ListOfProjectContactPerson,
          );
        }
        setShowSendEmailInvoiceModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCustomer_email = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (emailCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(emailCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);
      formikSendEmailInvoice.setFieldValue(
        "emailCustomerContactPersonIDEncrypted",
        "",
      );
      formikSendEmailInvoice.setFieldValue("emailContactPerson", "");
      formikSendEmailInvoice.setFieldValue("emailDesignation", "");
      formikSendEmailInvoice.setFieldValue("emailMobileNo", "");
      formikSendEmailInvoice.setFieldValue("emailEmailID", "");
      formikSendEmailInvoice.setFieldValue("emailContactPersonID", "");
    }
  }, [emailCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_email = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmailContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  const addAdditionalContactPerson_email = () => {
    if (emailCustomerIDEncrypted && emailCustomerContactPersonIDEncrypted) {
      if (
        emailListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            emailCustomerContactPersonIDEncrypted,
        )?.length == 0
      ) {
        formikSendEmailInvoice.setFieldValue(
          "emailListOfAdditionalContactPerson",
          [
            ...emailListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: emailCustomerName,
              CustomerContactPersonIDEncrypted:
                emailCustomerContactPersonIDEncrypted,
              ContactPerson: emailContactPerson,
              Designation: emailDesignation,
              MobileNo: emailMobileNo,
              EmailID: emailEmailID,
              ContactPersonID: emailContactPersonID,
            },
          ],
        );
        formikSendEmailInvoice.setFieldValue(
          "emailCustomerContactPersonIDEncrypted",
          "",
        );
        formikSendEmailInvoice.setFieldValue("emailContactPerson", "");
        formikSendEmailInvoice.setFieldValue("emailDesignation", "");
        formikSendEmailInvoice.setFieldValue("emailMobileNo", "");
        formikSendEmailInvoice.setFieldValue("emailEmailID", "");
        formikSendEmailInvoice.setFieldValue("emailContactPersonID", "");
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!emailCustomerIDEncrypted) {
        formikSendEmailInvoice.setFieldError(
          "emailCustomerIDEncrypted",
          "Customer is required field",
        );
        formikSendEmailInvoice.setFieldTouched(
          "emailCustomerIDEncrypted",
          true,
        );
      }
      if (!emailCustomerContactPersonIDEncrypted) {
        formikSendEmailInvoice.setFieldError(
          "emailCustomerContactPersonIDEncrypted",
          "Contact Person is required field",
        );
        formikSendEmailInvoice.setFieldTouched(
          "emailCustomerContactPersonIDEncrypted",
          true,
        );
      }
    }
  };

  const handleValidSubmitSendEmailInvoice = async (values) => {
    if (values?.InvoiceIDEncrypted) {
      let listOfAdditionalEmails = values?.emailAdditionalEmailID?.trim()
        ? cleanCsvString(values?.emailAdditionalEmailID)?.split(",")
        : [];
      if (
        values?.emailListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true,
        )?.length == 0 &&
        values?.emailListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true,
        )?.length == 0 &&
        listOfAdditionalEmails?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional email to send!",
        );
      } else {
        if (
          listOfAdditionalEmails?.length > 0 &&
          listOfAdditionalEmails?.filter((x) => validateEmail(x) == null)
            ?.length > 0
        ) {
          formikSendEmailInvoice.setFieldError(
            "emailAdditionalEmailID",
            "Please check it contains invalid email address",
          );
          formikSendEmailInvoice.setFieldTouched(
            "emailAdditionalEmailID",
            true,
          );
        } else {
          setIsLoading(true);

          let emailCsv = "";
          Promise.all(
            values?.emailListOfProjectContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            values?.emailListOfAdditionalContactPerson
              ?.filter((x) => x.IsSelected == true)
              ?.map((x) => {
                emailCsv =
                  emailCsv + x.EmailID + ":::" + x.ContactPersonID + ", ";
              }),
            listOfAdditionalEmails?.map((email) => {
              emailCsv = emailCsv + email + ":::" + 0 + ", ";
            }),
            (emailCsv = cleanCsvString(emailCsv)),
          );

          setIsLoading(true);
          await post(POST_InvoiceEmailSend, {
            InvoiceIDEncrypted: values?.InvoiceIDEncrypted,
            BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
            CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
            EmailIDs: emailCsv,
          })
            .then((response) => {
              if (response?.IsSuccess) {
                successMessage(response?.Message);
                setShowSendEmailInvoiceModal(false);
                getData(currentPage, currentSizePerPage);
              } else {
                errorMessage(response?.Message);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              console.log(error);
              setIsLoading(false);
            });
        }
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const downloadInvoicePDF = async (invoiceID) => {
    setIsLoading(true);
    await post(POST_InvoiceDownloadPDF, {
      InvoiceIDEncrypted: invoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: 2, ///* 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printInvoice = async (invoiceID, copyType) => {
    setIsLoading(true);
    await post(POST_InvoicePrint, {
      InvoiceIDEncrypted: invoiceID,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      CopyType: copyType, ///* 1 = Duplicate, 2 = Original */
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFrameInvoice");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showInvoiceDetailChangeModal, setShowInvoiceDetailChangeModal] =
    useState(false);

  const validationSchemaInvoiceDetailChange = Yup.object().shape({});

  const formikInvoiceDetailChange = useFormik({
    validationSchema: validationSchemaInvoiceDetailChange,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitInvoiceDetailChange(values, formikHelpers),
    initialValues: {
      InvoiceIDEncrypted: "",
      InvoiceNo: "",
      BillExcelFilePath: "",
      BillExcelFileKey: "",
      BillExcelFileUrl: "",
      BillPdfFilePath: "",
      BillPdfFileKey: "",
      BillPdfFileUrl: "",
      Narration: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      BillExcelFilePath,
      BillExcelFileKey,
      BillExcelFileUrl,
      BillPdfFilePath,
      BillPdfFileKey,
      BillPdfFileUrl,
    },
  } = formikInvoiceDetailChange;

  const openInvoiceDetailChangeDialog = async (invoiceID, invoiceNo) => {
    formikInvoiceDetailChange.resetForm();
    formikInvoiceDetailChange.setFieldValue("InvoiceNo", invoiceNo);
    formikInvoiceDetailChange.setFieldValue("InvoiceIDEncrypted", invoiceID);
    setIsLoading(true);
    await post(POST_GetInvoiceDetailByID, {
      InvoiceIDEncrypted: invoiceID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let p = response?.InvoiceInfo;
          formikInvoiceDetailChange.setFieldValue("Narration", p?.Narration);
          formikInvoiceDetailChange.setFieldValue(
            "BillExcelFileUrl",
            p?.BillExcelPath,
          );
          formikInvoiceDetailChange.setFieldValue(
            "BillPdfFileUrl",
            p?.BillPDFPath,
          );
          setShowInvoiceDetailChangeModal(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmitInvoiceDetailChange = (values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("InvoiceIDEncrypted", values?.InvoiceIDEncrypted);
    formData.append("ModifiedByEncrypted", AuthUser?.ReferenceIDEncrypt);
    formData.append("BillPDFFile", values?.BillPdfFilePath);
    formData.append("BillExcelFile", values?.BillExcelFilePath);
    formData.append("BillPDFPath", values?.BillPdfFileUrl);
    formData.append("BillExcelPath", values?.BillExcelFileUrl);
    formData.append("Narration", values?.Narration);

    postFormData(POST_InvoiceChangeDetails, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setShowInvoiceDetailChangeModal(false);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const uploadBillExcelFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.excel|.sheet)$/;

      if (!file.type.match(pattern)) {
        formikInvoiceDetailChange.setFieldValue(
          "BillExcelFileKey",
          Math.random().toString(9).substring(2, 9),
        );
        formikInvoiceDetailChange.setFieldValue("BillExcelFilePath", "");
        warningMessage("Select valid file!");
      } else {
        formikInvoiceDetailChange.setFieldValue("BillExcelFilePath", file);
      }
    } else {
      formikInvoiceDetailChange.setFieldValue("BillExcelFilePath", "");
      formikInvoiceDetailChange.setFieldValue(
        "BillExcelFileKey",
        Math.random().toString(9).substring(2, 9),
      );
    }
  };

  const downloadBillExcelFile = (e) => {
    window.open(
      BillExcelFilePath
        ? URL.createObjectURL(BillExcelFilePath)
        : BillExcelFileUrl,
      "_blank",
    );
  };

  const deleteBillExcelFile = (e) => {
    formikInvoiceDetailChange.setFieldValue("BillExcelFilePath", "");
    formikInvoiceDetailChange.setFieldValue(
      "BillExcelFileKey",
      Math.random().toString(9).substring(2, 9),
    );
    formikInvoiceDetailChange.setFieldValue("BillExcelFileUrl", "");
  };

  const uploadBillPdfFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.pdf)$/;

      if (!file.type.match(pattern)) {
        formikInvoiceDetailChange.setFieldValue(
          "BillPdfFileKey",
          Math.random().toString(9).substring(2, 9),
        );
        formikInvoiceDetailChange.setFieldValue("BillPdfFilePath", "");
        warningMessage("Select valid file!");
      } else {
        formikInvoiceDetailChange.setFieldValue("BillPdfFilePath", file);
      }
    } else {
      formikInvoiceDetailChange.setFieldValue("BillPdfFilePath", "");
      formikInvoiceDetailChange.setFieldValue(
        "BillPdfFileKey",
        Math.random().toString(9).substring(2, 9),
      );
    }
  };

  const downloadBillPdfFile = (e) => {
    window.open(
      BillPdfFilePath ? URL.createObjectURL(BillPdfFilePath) : BillPdfFileUrl,
      "_blank",
    );
  };

  const deleteBillPdfFile = (e) => {
    formikInvoiceDetailChange.setFieldValue("BillPdfFilePath", "");
    formikInvoiceDetailChange.setFieldValue(
      "BillPdfFileKey",
      Math.random().toString(9).substring(2, 9),
    );
    formikInvoiceDetailChange.setFieldValue("BillPdfFileUrl", "");
  };

  const generateEInvoice = (invoiceID) => {
    setIsLoading(true);
    post(POST_EInvoice_Generate, {
      EInvoiceType: 1, // 1 - Invoice, 2 - Credit Note, 3 - Debit Note
      IDEncrypted: invoiceID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [
    showSendWhatsAppMessageInvoiceModal,
    setShowSendWhatsAppMessageInvoiceModal,
  ] = useState(false);

  const validationSchemaSendWhatsAppMessageInvoice = Yup.object().shape({});

  const formikSendWhatsAppMessageInvoice = useFormik({
    validationSchema: validationSchemaSendWhatsAppMessageInvoice,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendWhatsAppMessageInvoice(values, formikHelpers),
    initialValues: {
      InvoiceIDEncrypted: "",
      InvoiceNo: "",
      WAPMemailListOfProjectContactPerson: [],
      WAPMemailListOfAdditionalContactPerson: [],
      WAPMemailAdditionalEmailID: "",
      WAPMemailCustomerIDEncrypted: "",
      WAPMemailCustomerName: "",
      WAPMemailCustomerContactPersonIDEncrypted: "",
      WAPMemailContactPerson: "",
      WAPMemailDesignation: "",
      WAPMemailMobileNo: "",
      WAPMemailEmailID: "",
      WAPMsscAdditionalMobileNo: "",
      WAPMemailContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      WAPMemailListOfProjectContactPerson,
      WAPMemailListOfAdditionalContactPerson,
      WAPMemailCustomerIDEncrypted,
      WAPMemailCustomerName,
      WAPMemailCustomerContactPersonIDEncrypted,
      WAPMemailContactPerson,
      WAPMemailDesignation,
      WAPMemailMobileNo,
      WAPMemailEmailID,
      WAPMsscAdditionalMobileNo,
      WAPMemailContactPersonID,
    },
  } = formikSendWhatsAppMessageInvoice;

  const handleValidSubmitSendWhatsAppMessageInvoice = async (values) => {
    if (values?.InvoiceIDEncrypted) {
      let additionalMobileNumbers = values?.WAPMsscAdditionalMobileNo?.trim();

      //const isValidFormat = /^[0-9]+(,[0-9]+)*$/.test(additionalMobileNumbers);
      if (values?.WAPMsscAdditionalMobileNo) {
        const isValidFormat = /^(\d{10})(,\d{10})*$/.test(
          additionalMobileNumbers,
        );

        if (!isValidFormat) {
          errorMessage(
            "Please enter valid mobile numbers separated by commas.",
          );
          return;
        }
      }
      // let listOfAdditionalMobileNo = values?.WAPMsscAdditionalMobileNo?.trim()
      //   ? cleanCsvString(values?.WAPMsscAdditionalMobileNo)?.split(",")
      //   : [];

      let listOfAdditionalMobileNo = additionalMobileNumbers
        ? cleanCsvString(additionalMobileNumbers)?.split(",")
        : [];

      if (
        values?.WAPMemailListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true,
        )?.length == 0 &&
        values?.WAPMemailListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true,
        )?.length == 0 &&
        listOfAdditionalMobileNo?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional mobile no to send message!",
        );
      } else {
        setIsLoading(true);

        let MobileNoCsv = "";
        Promise.all(
          values?.WAPMemailListOfProjectContactPerson?.filter(
            (x) => x.IsSelected == true,
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAPMemailListOfAdditionalContactPerson?.filter(
            (x) => x.IsSelected == true,
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          listOfAdditionalMobileNo?.map((mno) => {
            MobileNoCsv = MobileNoCsv + mno + ":::" + 0 + ", ";
          }),
          (MobileNoCsv = cleanCsvString(MobileNoCsv)),
        );

        let payload = {
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          InvoiceIDEncrypted: values?.InvoiceIDEncrypted,
          CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
          MobileNos: MobileNoCsv,
        };

        //console.log("payload", payload);
        //return;

        await post(POST_InvoiceWhatsAppMessageSend, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setShowSendWhatsAppMessageInvoiceModal(false);
              getData(currentPage, currentSizePerPage);
            } else {
              errorMessage(response?.Message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  useEffect(() => {
    if (WAPMemailCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(WAPMemailCustomerIDEncrypted);
    } else {
      setEmailContactPersonOptions([]);
      formikSendWhatsAppMessageInvoice.setFieldValue(
        "WAPMemailCustomerContactPersonIDEncrypted",
        "",
      );
      formikSendWhatsAppMessageInvoice.setFieldValue(
        "WAPMemailContactPerson",
        "",
      );
      formikSendWhatsAppMessageInvoice.setFieldValue(
        "WAPMemailDesignation",
        "",
      );
      formikSendWhatsAppMessageInvoice.setFieldValue("WAPMemailMobileNo", "");
      formikSendWhatsAppMessageInvoice.setFieldValue("WAPMemailEmailID", "");
      formikSendWhatsAppMessageInvoice.setFieldValue(
        "WAPMemailContactPersonID",
        "",
      );
    }
  }, [WAPMemailCustomerIDEncrypted]);

  const openInvoiceWhatsAppMessageDialog = async (invoiceID, invoiceNo) => {
    formikSendWhatsAppMessageInvoice.resetForm();
    formikSendWhatsAppMessageInvoice.setFieldValue("InvoiceNo", invoiceNo);
    formikSendWhatsAppMessageInvoice.setFieldValue(
      "InvoiceIDEncrypted",
      invoiceID,
    );
    setIsLoading(true);
    await post(POST_GetInvoiceSendEmailDetails, {
      InvoiceIDEncrypted: invoiceID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendWhatsAppMessageInvoice.setFieldValue(
            "WAPMemailListOfProjectContactPerson",
            response?.ListOfProjectContactPerson?.filter(
              (item) => item.MobileNo !== "",
            )?.map((x) => ({
              ...x,
              IsSelected: false,
            })),
            //response?.ListOfProjectContactPerson
          );
        }
        setShowSendWhatsAppMessageInvoiceModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addAdditionalContactPerson_WAPM = () => {
    if (
      WAPMemailCustomerIDEncrypted &&
      WAPMemailCustomerContactPersonIDEncrypted
    ) {
      if (
        WAPMemailListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            WAPMemailCustomerContactPersonIDEncrypted,
        )?.length == 0
      ) {
        formikSendWhatsAppMessageInvoice.setFieldValue(
          "WAPMemailListOfAdditionalContactPerson",
          [
            ...WAPMemailListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: WAPMemailCustomerName,
              CustomerContactPersonIDEncrypted:
                WAPMemailCustomerContactPersonIDEncrypted,
              ContactPerson: WAPMemailContactPerson,
              Designation: WAPMemailDesignation,
              MobileNo: WAPMemailMobileNo,
              EmailID: WAPMemailEmailID,
              ContactPersonID: WAPMemailContactPersonID,
            },
          ],
        );
        formikSendWhatsAppMessageInvoice.setFieldValue(
          "WAPMemailCustomerContactPersonIDEncrypted",
          "",
        );
        formikSendWhatsAppMessageInvoice.setFieldValue(
          "WAPMemailContactPerson",
          "",
        );
        formikSendWhatsAppMessageInvoice.setFieldValue(
          "WAPMemailDesignation",
          "",
        );
        formikSendWhatsAppMessageInvoice.setFieldValue("WAPMemailMobileNo", "");
        formikSendWhatsAppMessageInvoice.setFieldValue("WAPMemailEmailID", "");
        formikSendWhatsAppMessageInvoice.setFieldValue(
          "WAPMemailContactPersonID",
          "",
        );
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!WAPMemailCustomerIDEncrypted) {
        formikSendWhatsAppMessageInvoice.setFieldError(
          "WAPMemailCustomerIDEncrypted",
          "Customer is required field",
        );
        formikSendWhatsAppMessageInvoice.setFieldTouched(
          "WAPMemailCustomerIDEncrypted",
          true,
        );
      }
      if (!WAPMemailCustomerContactPersonIDEncrypted) {
        formikSendWhatsAppMessageInvoice.setFieldError(
          "WAPMemailCustomerContactPersonIDEncrypted",
          "Contact Person is required field",
        );
        formikSendWhatsAppMessageInvoice.setFieldTouched(
          "WAPMemailCustomerContactPersonIDEncrypted",
          true,
        );
      }
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Invoice</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i
                      className="fa fa-window-restore me-2"
                      aria-hidden="true"
                    ></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 52 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 52 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-invoice"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Invoice
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Invoice No"
                              name="InvoiceNo"
                              placeholder={"Search Invoice No"}
                              component={CustomInput}
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">Invoice Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search Inward No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Payment Status"
                              name="PaymentStatus"
                              placeholder={"Select Payment Status"}
                              options={paymentStatusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Project"
                              name="CustomerProjectIDEncrypted"
                              placeholder={"Select Project"}
                              options={customerProjectOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                              menuStyles={{
                                position: "absolute",
                                right: 0,
                              }}
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="Representative"
                              name="CustomerRepresentativeIDEncrypt"
                              placeholder={"Select Representative"}
                              options={customerRepresentativeOptions}
                              component={CustomSelect}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Status"
                              name="Status"
                              placeholder={"Select Status"}
                              options={statusOptions}
                              component={CustomSelect}
                              isClearable={false}
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                {/* This is commented because of Email Configuration form has Is Email send option so if user tick that option then the email instant will be selected by user which data has been inserted.
                {AuthUser?.IsInvoiceEmailSetup == false && (
                  <div className="text-danger">
                    Note: In Application setup - Invoice Mail Setting is
                    pending. So user wan't be able to send emails.
                  </div>
                )} */}
                <div
                  id="Invoice-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="Invoice-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="7%" style={{ minWidth: "90px" }}></th>
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceNo");
                          }}
                        >
                          Invoice No{" "}
                          <span className="ml-1">
                            {sortBy == "InvoiceNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "7%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceDate");
                          }}
                        >
                          Invoice Date{" "}
                          <span className="ml-1">
                            {sortBy == "InvoiceDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "9%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "14%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ContactPerson");
                          }}
                        >
                          Contact Person{" "}
                          <span className="ml-1">
                            {sortBy == "ContactPerson" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("NetAmount");
                          }}
                        >
                          Invoice Amount{" "}
                          <span className="ml-1">
                            {sortBy == "NetAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "7%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("ModeOfDispatch");
                          }}
                        >
                          Mode Of Dispatch{" "}
                          <span className="ml-1">
                            {sortBy == "ModeOfDispatch" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedBy");
                          }}
                        >
                          Created By{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "5%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("PaymentStatus");
                          }}
                        >
                          Payment Status{" "}
                          <span className="ml-1">
                            {sortBy == "PaymentStatus" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "5%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("WhatsAppMessageSend");
                          }}
                        >
                          WhatsApp Send{" "}
                          <span className="ml-1">
                            {sortBy == "WhatsAppMessageSend" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        {AuthUser?.Permissions?.Email == 1 ? (
                          <th
                            style={{
                              width: "5%",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                            onClick={() => {
                              handleClickSorting("MailSent");
                            }}
                          >
                            Mail Send{" "}
                            <span className="ml-1">
                              {sortBy == "MailSent" ? (
                                orderBy == "desc" ? (
                                  <i
                                    className="fa fa-arrow-down ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-arrow-up ms-2 fs-14"
                                    style={{ opacity: "0.7" }}
                                  />
                                )
                              ) : (
                                <i
                                  className="fa fa-sort ms-2 fs-14"
                                  style={{ opacity: "0.3" }}
                                />
                              )}
                            </span>
                          </th>
                        ) : (
                          ""
                        )}
                        {canSeePifSync && (
                          <th style={{ width: "5%", textAlign: "left" }}>Tally Sync</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceList?.length > 0 ? (
                        invoiceList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                                minWidth: "100px",
                              }}
                            >
                              {item?.IsCancelled == false ? (
                                <>
                                  {AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 52 && x?.IsEdit,
                                  )?.length > 0 ? (
                                    <Link
                                      to={`/edit-invoice/${window.btoa(
                                        item.InvoiceIDEncrypted,
                                      )}`}
                                      className="icon-box icon-box-md me-1"
                                      title="Edit"
                                    >
                                      {SVGICON.EditPrimary}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Original Copy"
                                    // title="Print"
                                    onClick={() => {
                                      printInvoice(item.InvoiceIDEncrypted, 2);
                                    }}
                                  >
                                    {SVGICON.Printer}
                                  </Link>
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Duplicate Copy"
                                    onClick={() => {
                                      printInvoice(item.InvoiceIDEncrypted, 1);
                                    }}
                                  >
                                    {SVGICON.Printer}
                                  </Link>
                                  {AuthUser?.Permissions?.Email == 1 ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Send Email"
                                      onClick={() => {
                                        openSendEmailInvoiceDialog(
                                          item.InvoiceIDEncrypted,
                                          item.InvoiceNo,
                                        );
                                      }}
                                    >
                                      {SVGICON.SendEmail}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  <Link
                                    to="#"
                                    className="icon-box icon-box-md me-1"
                                    title="Export PDF"
                                    onClick={() => {
                                      downloadInvoicePDF(
                                        item.InvoiceIDEncrypted,
                                      );
                                    }}
                                  >
                                    {SVGICON.PDF}
                                  </Link>
                                  {(AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) => x?.FormID == 52 && x?.IsDelete,
                                    )?.length > 0) &&
                                  item?.PaymentStatus == false &&
                                  item.NetAmount == item.PendingAmount &&
                                  (item.EInvoiceIRNNo == "" ||
                                    (item.EInvoiceIRNNo != "" &&
                                      item.EInvoiceCanBeCancelled == true)) ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Cancel"
                                      onClick={() => {
                                        cancelInvoice(
                                          item.InvoiceIDEncrypted,
                                          item.InvoiceNo,
                                          item.EInvoiceIRNNo,
                                        );
                                      }}
                                    >
                                      {SVGICON.Cancel}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  {AuthUser?.UserType !== 1 ||
                                  formsList?.filter(
                                    (x) => x?.FormID == 52 && x?.IsEdit,
                                  )?.length > 0 ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Change Invoice Detail"
                                      onClick={() => {
                                        openInvoiceDetailChangeDialog(
                                          item.InvoiceIDEncrypted,
                                          item.InvoiceNo,
                                        );
                                      }}
                                    >
                                      {SVGICON.EditSquare}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                  {(AuthUser?.UserType !== 1 ||
                                    formsList?.filter(
                                      (x) =>
                                        x?.FormID == 52 &&
                                        (x?.IsEdit || x.IsAdd),
                                    )?.length > 0) &&
                                  AuthUser?.EInvoiceApplicable == true &&
                                  item.GenerateEInvoice == false &&
                                  item.GSTNo ? (
                                    <Link
                                      to="#"
                                      className="icon-box icon-box-md me-1"
                                      title="Generate E-Invoice"
                                      onClick={(e) => {
                                        customConfirmDialog(
                                          "Generate E-Invoice",
                                          `Do you want to generate ${item.InvoiceNo} E-Invoice?`,
                                          () => {
                                            generateEInvoice(
                                              item.InvoiceIDEncrypted,
                                            );
                                          },
                                          true,
                                        );
                                      }}
                                    >
                                      {SVGICON.Invoice}
                                    </Link>
                                  ) : (
                                    ""
                                  )}

                                  {AuthUser?.UserType == 1 &&
                                  AuthUser?.Permissions?.Whatsup == 1 &&
                                  formsList?.filter(
                                    (x) =>
                                      x?.FormID == 81 &&
                                      (x?.IsAdd || x?.IsEdit),
                                  )?.length > 0 ? (
                                    <>
                                      <Link
                                        className="icon-box icon-box-md me-1"
                                        title="Send Invoice in WhatsApp"
                                        onClick={() => {
                                          openInvoiceWhatsAppMessageDialog(
                                            item.InvoiceIDEncrypted,
                                            item.InvoiceNo,
                                          );
                                        }}
                                      >
                                        {SVGICON.WhatsApp}
                                      </Link>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <span className="text-danger fs-12">
                                  Cancelled&nbsp;
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    responsive={true}
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <strong className="p-1">
                                          {item.CancelledReason}
                                        </strong>
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <i
                                        className="fa fa-info-circle"
                                        style={{
                                          cursor: "pointer",
                                          color: "#9698ab",
                                        }}
                                      ></i>
                                    </span>
                                  </OverlayTrigger>
                                </span>
                              )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.InvoiceNo}
                              {AuthUser?.EInvoiceApplicable == true &&
                                item.GSTNo && (
                                  <>
                                    <br></br>
                                    {item.CancelEInvoice == true ? (
                                      <span className="fs-12 text-danger">
                                        E-Invoice: Cancelled
                                      </span>
                                    ) : item.GenerateEInvoice == true ? (
                                      <span className="fs-12 text-primary">
                                        E-Invoice: Done
                                      </span>
                                    ) : (
                                      <span className="fs-12 text-danger">
                                        E-Invoice: Pending
                                      </span>
                                    )}
                                  </>
                                )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.InvoiceDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InwardNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TCNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.BillingCustomerName}
                              {item.GSTNo && (
                                <>
                                  <br></br>
                                  <span className="fs-12 text-primary">
                                    {item.GSTNo}
                                  </span>
                                </>
                              )}
                              {item.CustomerRepresentativeName ? (
                                <>
                                  <br></br>
                                  <span className="fs-12">
                                    {" "}
                                    <b>Representative :</b>{" "}
                                    {item.CustomerRepresentativeName}
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.ContactPerson}{" "}
                              {item.MobileNo ? (
                                <>
                                  <br></br>
                                  {item.MobileNo}
                                </>
                              ) : (
                                ""
                              )}
                              {item.EmailID ? (
                                <>
                                  <br></br>
                                  {item.EmailID}
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.NetAmount}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.ModeOfDispatchName}
                            </td>

                            <td style={{ verticalAlign: "top" }}>
                              {item.CreatedBy}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                              }}
                            >
                              {item.PaymentStatus == true ? (
                                "Paid"
                              ) : (
                                <>
                                  Pending <br></br>
                                  <span className="fs-12">
                                    <i>({item.PendingAmount})</i>
                                  </span>
                                </>
                              )}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.WhatsAppMessageSend == true ? (
                                <>
                                  Yes <br></br>
                                  {item.WhatsAppMessageSendBy}
                                  <br></br>
                                  {item.WhatsAppMessageSendDate}
                                </>
                              ) : (
                                "No"
                              )}
                            </td>
                            {AuthUser?.Permissions?.Email == 1 ? (
                              <td
                                style={{
                                  verticalAlign: "top",
                                  textAlign: "left",
                                }}
                              >
                                {item.MailSent == true ? (
                                  <>
                                    Yes <br></br>
                                    {item.MailSentBy}
                                    <br></br>
                                    {item.MailSentDate}
                                  </>
                                ) : (
                                  "No"
                                )}
                              </td>
                            ) : (
                              ""
                            )}
                            {canSeePifSync && (
                              <td style={{ verticalAlign: "top", textAlign: "left" }}>
                                {(() => {
                                  const s = pifSync[item.InvoiceNo];

                                  // Cancelled invoice — show the Tally voucher-cancellation state.
                                  if (item.IsCancelled) {
                                    const wasSynced =
                                      s &&
                                      (s.PifSyncStatus === 3 ||
                                        s.PifSyncStatus === 6 ||
                                        s.CancelJobStatus != null);
                                    if (!wasSynced)
                                      return (
                                        <span className="text-muted fs-12">—</span>
                                      );
                                    const cPill = pifCancelJobPill(
                                      s ? s.CancelJobStatus : null
                                    );
                                    const canCancelNow =
                                      canQueuePifSync &&
                                      (s.CancelJobStatus == null ||
                                        s.CancelJobStatus === 4 ||
                                        s.CancelJobStatus === 5);
                                    return (
                                      <>
                                        {cPill ? (
                                          <span
                                            className={`badge badge-${cPill.badge} light`}
                                            title={s.CancelJobError || cPill.label}
                                          >
                                            {cPill.label}
                                          </span>
                                        ) : (
                                          <span className="text-muted fs-12">
                                            synced — not cancelled in Tally
                                          </span>
                                        )}
                                        {canCancelNow && (
                                          <Link
                                            to="#"
                                            className="d-block fs-12"
                                            title="Cancel the Tally voucher for this invoice"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              cancelInvoiceInTally(item);
                                            }}
                                          >
                                            {s.CancelJobStatus
                                              ? "Retry cancel"
                                              : "Cancel in Tally"}
                                          </Link>
                                        )}
                                      </>
                                    );
                                  }

                                  const pill = pifInvoiceSyncPill(
                                    s ? s.PifSyncStatus : null
                                  );
                                  if (!pill || (s && s.PifSyncStatus === 0))
                                    return (
                                      <>
                                        <span className="text-muted fs-12">
                                          not queued
                                        </span>
                                        {canQueuePifSync && (
                                          <Link
                                            to="#"
                                            className="d-block fs-12"
                                            title="Queue this invoice for Tally sync"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              queueInvoiceForTally(item);
                                            }}
                                          >
                                            Sync to Tally
                                          </Link>
                                        )}
                                      </>
                                    );
                                  return (
                                    <>
                                      {s && s.PifQueueId ? (
                                        <Link
                                          to={`/sync-detail/${window.btoa(
                                            String(s.PifQueueId)
                                          )}`}
                                          title={s.LastError || pill.label}
                                        >
                                          <span
                                            className={`badge badge-${pill.badge} light`}
                                          >
                                            {pill.label}
                                          </span>
                                        </Link>
                                      ) : (
                                        <span
                                          className={`badge badge-${pill.badge} light`}
                                        >
                                          {pill.label}
                                        </span>
                                      )}
                                      {canQueuePifSync &&
                                        s &&
                                        s.PifQueueId &&
                                        s.PifSyncStatus === 3 && (
                                          <Link
                                            to="#"
                                            className="d-block fs-12"
                                            title="Push the edited invoice to Tally (updates the voucher)"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              resyncInvoiceToTally(item, s);
                                            }}
                                          >
                                            Re-sync
                                          </Link>
                                        )}
                                    </>
                                  );
                                })()}
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={14} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <hr className="mt-0 mb-0"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showCancelInvoiceModal}
            onHide={setShowCancelInvoiceModal}
            size="lg"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCancelInvoice}>
                <Form onSubmit={formikCancelInvoice.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Cancel Invoice - {formikCancelInvoice.values.InvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowCancelInvoiceModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={12}>
                        <Field
                          label="Cancel Reason"
                          name="CancelReason"
                          placeholder={"Cancel Reason"}
                          component={CustomInput}
                          maxLength={500}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowCancelInvoiceModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendEmailInvoiceModal}
            onHide={setShowSendEmailInvoiceModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendEmailInvoice}>
                <Form onSubmit={formikSendEmailInvoice.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Invoice Email - {formikSendEmailInvoice.values.InvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowSendEmailInvoiceModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {emailListOfProjectContactPerson?.length > 0 ? (
                              emailListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendEmailInvoice.setFieldValue(
                                            `emailListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected,
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="emailCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={emailCustomerName}
                          labelFieldName="emailCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="emailCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendEmailInvoice.setFieldValue(
                              "emailCustomerContactPersonIDEncrypted",
                              e?.value ?? "",
                            );
                            formikSendEmailInvoice.setFieldValue(
                              "emailContactPerson",
                              e?.label ?? "",
                            );
                            formikSendEmailInvoice.setFieldValue(
                              "emailDesignation",
                              e?.Designation ?? "",
                            );
                            formikSendEmailInvoice.setFieldValue(
                              "emailMobileNo",
                              e?.MobileNo ?? "",
                            );
                            formikSendEmailInvoice.setFieldValue(
                              "emailEmailID",
                              e?.EmailID ?? "",
                            );
                            formikSendEmailInvoice.setFieldValue(
                              "emailContactPersonID",
                              e?.ContactPersonID ?? "",
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_email();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {emailListOfAdditionalContactPerson?.length >
                                0 ? (
                                  emailListOfAdditionalContactPerson?.map(
                                    (item, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        <td>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="checkIsSelectedACP"
                                            checked={item?.IsSelected}
                                            onChange={() => {
                                              formikSendEmailInvoice.setFieldValue(
                                                `emailListOfAdditionalContactPerson[${idx}].IsSelected`,
                                                !item?.IsSelected,
                                              );
                                            }}
                                            style={{ cursor: "pointer" }}
                                          ></input>
                                        </td>
                                        <td>{item?.CustomerName}</td>
                                        <td>{item?.ContactPerson}</td>
                                        <td>{item?.Designation}</td>
                                        <td>{item?.MobileNo}</td>
                                        <td style={{ textAlign: "left" }}>
                                          {item?.EmailID}
                                        </td>
                                      </tr>
                                    ),
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Additional Email"
                          name="emailAdditionalEmailID"
                          placeholder={"Enter Additional Email"}
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-envelope"></i> Send Email
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowSendEmailInvoiceModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showInvoiceDetailChangeModal}
            onHide={setShowInvoiceDetailChangeModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikInvoiceDetailChange}>
                <Form onSubmit={formikInvoiceDetailChange.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Invoice - {formikInvoiceDetailChange.values.InvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowInvoiceDetailChangeModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={6}>
                        {(BillExcelFileUrl || BillExcelFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteBillExcelFile}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Download"
                              style={{ float: "right" }}
                              onClick={downloadBillExcelFile}
                            >
                              {SVGICON.Download}
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label className="mb-1">Upload Bill Excel</label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="BillExcelFilePath"
                            accept=".xls,.xlsx"
                            key={BillExcelFileKey || ""}
                            onChange={(e) => {
                              uploadBillExcelFile(e);
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        {(BillPdfFileUrl || BillPdfFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteBillPdfFile}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Download"
                              style={{ float: "right" }}
                              onClick={downloadBillPdfFile}
                            >
                              {SVGICON.Download}
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label className="mb-1">Upload Bill PDF</label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="BillPdfFilePath"
                            accept=".pdf"
                            key={BillPdfFileKey || ""}
                            onChange={(e) => {
                              uploadBillPdfFile(e);
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <Field
                          label="Narration"
                          name="Narration"
                          placeholder={"Enter Narration"}
                          component={CustomTextArea}
                          maxLength={2000}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowInvoiceDetailChangeModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>

          <Modal
            className="fade"
            show={showSendWhatsAppMessageInvoiceModal}
            onHide={setShowSendWhatsAppMessageInvoiceModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendWhatsAppMessageInvoice}>
                <Form onSubmit={formikSendWhatsAppMessageInvoice.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Invoice Send WhatsApp Message -{" "}
                      {formikSendWhatsAppMessageInvoice.values.InvoiceNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSendWhatsAppMessageInvoiceModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Project Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {WAPMemailListOfProjectContactPerson?.length > 0 ? (
                              WAPMemailListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendWhatsAppMessageInvoice.setFieldValue(
                                            `WAPMemailListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected,
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="WAPMemailCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={WAPMemailCustomerName}
                          labelFieldName="WAPMemailCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="WAPMemailCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={emailContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailCustomerContactPersonIDEncrypted",
                              e?.value ?? "",
                            );
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailContactPerson",
                              e?.label ?? "",
                            );
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailDesignation",
                              e?.Designation ?? "",
                            );
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailMobileNo",
                              e?.MobileNo ?? "",
                            );
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailEmailID",
                              e?.EmailID ?? "",
                            );
                            formikSendWhatsAppMessageInvoice.setFieldValue(
                              "WAPMemailContactPersonID",
                              e?.ContactPersonID ?? "",
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_WAPM();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAPMemailListOfAdditionalContactPerson?.length >
                                0 ? (
                                  WAPMemailListOfAdditionalContactPerson?.filter(
                                    (x) => x.MobileNo !== "",
                                  ).map((item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedACP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikSendWhatsAppMessageInvoice.setFieldValue(
                                              `WAPMemailListOfAdditionalContactPerson[${idx}].IsSelected`,
                                              !item?.IsSelected,
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.CustomerName}</td>
                                      <td>{item?.ContactPerson}</td>
                                      <td>{item?.Designation}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          //type="number"
                          label="Additional Mobile No"
                          name="WAPMsscAdditionalMobileNo"
                          placeholder={
                            "Enter Additional Mobile No like 1234567890,0987654321"
                          }
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fab la-whatsapp me-2" /> Send Message
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSendWhatsAppMessageInvoiceModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFrameInvoice`}
          title="Invoice"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default Invoice;
